import Cookies from 'js-cookie';

// store api key in a js cookie for 24 hours
export const storeApiKeyInCookie = (API_KEY: string): void => {
    Cookies.set('API_KEY', API_KEY, { expires: 365, sameSite: 'strict', secure: true });
};

